import { render, staticRenderFns } from "./editInfo.vue?vue&type=template&id=4c2a1f04&scoped=true&"
import script from "./editInfo.vue?vue&type=script&lang=js&"
export * from "./editInfo.vue?vue&type=script&lang=js&"
import style0 from "./editInfo.vue?vue&type=style&index=0&id=4c2a1f04&lang=scss&scoped=true&"
import style1 from "./editInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2a1f04",
  null
  
)

export default component.exports